/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `MatrixEnvironmentType*`'s.
 * @export
 */
export type MatrixEnvironmentType =
  | ConsoleInstanceMatrixEnvironmentTypeProduction
  | ConsoleInstanceMatrixEnvironmentTypeDevelopment;

/**
 * All of the possible `ConsoleInstanceMatrixEnvironmentType*`'s.
 * @export
 */
export type ConsoleInstanceMatrixEnvironmentType =
  | ConsoleInstanceMatrixEnvironmentTypeProduction
  | ConsoleInstanceMatrixEnvironmentTypeDevelopment
  | ConsoleInstanceMatrixEnvironmentTypeEvaluation
  | ConsoleInstanceMatrixEnvironmentTypeInternal
  | ConsoleInstanceMatrixEnvironmentTypeCanary
  | ConsoleInstanceMatrixEnvironmentTypeDedicated;

/**
 * The matrix instance production environment type.
 * @export
 */
export type ConsoleInstanceMatrixEnvironmentTypeProduction = typeof CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_PRODUCTION;

/**
 * The matrix instance development environment type.
 * @export
 */
export type ConsoleInstanceMatrixEnvironmentTypeDevelopment =
  typeof CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEVELOPMENT;

/**
 * The matrix instance evaluation environment type.
 * @export
 */
export type ConsoleInstanceMatrixEnvironmentTypeEvaluation = typeof CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_EVALUATION;

/**
 * The matrix instance internal environment type.
 * @export
 */
export type ConsoleInstanceMatrixEnvironmentTypeInternal = typeof CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_INTERNAL;

/**
 * The matrix instance canary environment type.
 * @export
 */
export type ConsoleInstanceMatrixEnvironmentTypeCanary = typeof CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_CANARY;

/**
 * The matrix instance dedicated environment type.
 * @export
 */
export type ConsoleInstanceMatrixEnvironmentTypeDedicated = typeof CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEDICATED;

/**
 * The matrix instance production environment constant.
 * @export
 */
export const CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_PRODUCTION = `production`;

/**
 * The matrix instance development environment constant.
 * @export
 */
export const CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEVELOPMENT = `development`;

/**
 * The matrix instance evaluation environment constant.
 * @export
 */
export const CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_EVALUATION = `evaluation`;

/**
 * The matrix instance internal environment constant.
 * @export
 */
export const CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_INTERNAL = `internal`;

/**
 * The matrix instance canary environment constant.
 * @export
 */
export const CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_CANARY = `canary`;

/**
 * The matrix instance dedicated environment constant.
 * @export
 */
export const CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEDICATED = `dedicated`;
